import axios from "axios";
import {API} from "../../../api/api";
import {HallsListFilters} from "../reducers/hallsListFilters.reducer";
import {HallsAPIRoutes} from "./apiRoutes";

const getHalls = ({
                      page,
                      search = null,
                      top = 10,
                      filters = null
                  }: {
    page: number;
    search: string;
    top: number;
    filters: HallsListFilters;
}) => {
    const odataParameters = {
        skip: page * top ? page * top : 0,
        top,
        orderby: "-created_on"
    };

    if (search) {
        odataParameters["search"] = search;
    }

    if (filters) {
        if (filters.market && filters.market.length > 0) {
            odataParameters["filter"] = `subsidiary_id in (${filters.market
                .map(c => c)
                .join(",")},)`;
        }

        if (filters.country && filters.country.length > 0) {
            odataParameters[
                "filter"
                ] = `subsidiary_country_code in ${filters.country
                .map(c => `"${c}"`)
                .join(",")}`;
        }

        if (filters.provider && filters.provider.length > 0) {
            const prepend = odataParameters["filter"]
                ? `${odataParameters["filter"]} and `
                : "";

            odataParameters["filter"] = `${prepend}subsidiary__company_id in ${filters.provider
                .map(c => `"${c}"`)
                .join(",")}`;
        }

        if (filters.hallStatus && filters.hallStatus.length > 0) {
            const prepend = odataParameters["filter"]
                ? `${odataParameters["filter"]} and `
                : "";

            const fullQuery = `${prepend}active eq ${filters.hallStatus}`;
            odataParameters["filter"] = fullQuery;
        }

        if (filters.search) {
            odataParameters["search"] = filters.search;
        }
    }

    if (odataParameters.hasOwnProperty("filter")) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        const fullQuery = `${prepend}deleted eq false`;
        odataParameters["filter"] = fullQuery;
    } else {
        odataParameters["filter"] = `deleted eq false`;
    }

    return API.request({
        routeID: HallsAPIRoutes.GET_HALLS,
        odataParameters
    });
};

const getHall = ({hallId}: { hallId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_HALL,
        routeParameters: {
            hall_id: hallId.toString()
        }
    });
};

const getServers = ({hallId, search, status, version}) => {
    let odataParameters = {
        top: 10000,
        skip: 0,
        orderby: "-id",
        filter: "deleted eq false"
    };

    if (search) {
        odataParameters["search"] = search;
    }
    if (hallId) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}hall_id eq ${hallId}`;
    }
    if (status) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}active eq ${status}`;
    }
    if (version && version.length > 0) {
        const prepend = odataParameters["filter"]
            ? `${odataParameters["filter"]} and `
            : "";

        odataParameters["filter"] = `${prepend}system_server_version in (${version
            .map(c => `'${c}'`)
            .join(",")},)`;
    }


    return API.request({
        routeID: HallsAPIRoutes.GET_SERVERS,
        odataParameters
    });
};

const getServer = ({server}: { server: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_SERVER,
        routeParameters: {
            server_id: server.toString()
        }
    });
};

const getHallListServers = ({hallIds}: { hallIds: number[] }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_SERVERS,
        odataParameters: {
            top: 10000,
            skip: 0,
            ...(hallIds.length && {filter: `hall_id in (${hallIds},)`}),
            orderby: "-id"
        }
    });
};

const getSubsidiaries = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: HallsAPIRoutes.GET_SUBSIDIARIES,
        odataParameters
    });
};

/* const getStatusTimestamp = ({ serverIds }: { serverIds: number[] }) => {
    const odataParameters = {
        select: ["when", "server_id"],
        filter: `server_id in ${serverIds}`,
        top: serverIds.length
    };

    return API.request({
        routeID: HallsAPIRoutes.GET_LATEST_STATUS_TIMESTAMP,
        odataParameters
    });
}; */

const getConfigurationsList = server => {
    const odataParameters = {
        filter: `server_id eq ${server}`,
        orderby: `version`
    };
    return API.request({
        routeID: HallsAPIRoutes.GET_CONFIGURATIONS_LIST,
        odataParameters
    });
};

const searchOSMAddress = address => {
    return axios.get(
        `https://nominatim.openstreetmap.org/search?q=${address
            .split(" ")
            .join("+")}&format=json&limit=10&addressdetails=1`
    );
};

const reverseOSMAddress = (lat, lon) => {
    return axios.get(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`
    );
};

const createHall = hallInfo => {
    let newhallInfo = {...hallInfo};
    return API.request({
        routeID: HallsAPIRoutes.CREATE_HALL,
        parameters: {
            ...newhallInfo
        }
    });
};

const updateHall = (hallId, newState) => {
    let newhallInfo = {...newState};

    return API.request({
        routeID: HallsAPIRoutes.UPDATE_HALL,
        routeParameters: {
            hall_id: hallId.toString()
        },
        parameters: {
            ...newhallInfo
        }
    });
};

const createServer = ({hallId, type, system_server_version, name, is_egames = false/*, perpetual_license*/}) => {
    return API.request({
        routeID: HallsAPIRoutes.CREATE_SERVER,
        parameters: {
            hall: hallId,
            type,
            system_server_version,
            name,
            is_egames,
            //perpetual_license
        }
    });
};
const cloneServer = ({id,system_server_version, is_egames = false}) => {
    const parameters: any = {};

    if (
        system_server_version !== undefined &&
        system_server_version !== null &&
        system_server_version !== "undefined"
    ) {
        parameters["system_server_version"] = system_server_version;
    }
    parameters["is_egames"] = is_egames;

    return API.request({
        routeID: HallsAPIRoutes.CLONE_SERVER,
        routeParameters: {
            server_id: id.toString()
        },
        parameters
    });
};

const updateServer = ({id, name}) => {
    return API.request({
        routeID: HallsAPIRoutes.EDIT_SERVER,
        routeParameters: {
            server_id: id.toString()
        },
        parameters: {
            name
        }
    });
};

/* const getCashSystems = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: HallsAPIRoutes.GET_CASH_SYSTEMS,
        odataParameters
    });
}; */

const getCoreVersions = () => {
    const odataParameters = {
        skip: 0,
        top: 10000
    };
    return API.request({
        routeID: HallsAPIRoutes.GET_CORE_VERSIONS,
        odataParameters
    });
};

const getTimezones = subsidiaryCountry => {
    const odataParameters = {
        skip: 0,
        top: 10000,
        filter: `country_id in (${subsidiaryCountry},)`
    };
    return API.request({
        routeID: HallsAPIRoutes.GET_TIMEZONES,
        odataParameters
    });
};

const activateHall = hallId => {
    return API.request({
        routeID: HallsAPIRoutes.ACTIVATE_HALL,
        routeParameters: {
            hall_id: hallId.toString()
        }
    });
};

const deleteHall = hallId => {
    return API.request({
        routeID: HallsAPIRoutes.DELETE_HALL,
        routeParameters: {
            hall_id: hallId.toString()
        }
    });
};

const activateServer = serverId => {
    return API.request({
        routeID: HallsAPIRoutes.ACTIVATE_SERVER,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const toggleServerDebugMode = serverId => {
    return API.request({
        routeID: HallsAPIRoutes.TOGGLE_SERVER_DEBUG_MODE,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const toggleServerPerpetualLicense = serverId => {
    return API.request({
        routeID: HallsAPIRoutes.TOGGLE_SERVER_PERPETUAL_LICENSE,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const getServersInfo = ({hall_id}: { hall_id: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.SERVERS_INFO,
        routeParameters: {
            hall_id: hall_id.toString()
        }
    });
};

const getCompareConfigurations = ({confIds}: { confIds: number[] }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_COMPARE_CONFIGURATIONS,
        odataParameters: {
            top: 10000,
            skip: 0,
            ...(confIds.length && {filter: `id in (${confIds},)`})
        }
    });
};

const uploadConfiguration = (file, server_id) => {
    return API.request({
        routeID: HallsAPIRoutes.CONFIG_UPLOAD,
        parameters: {
            file
        },
        routeParameters: {
            server_id
        }
    });
};

const getServerLicenseState = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_SERVER_LICENSE_STATE,
        odataParameters: {
            top: 10000,
            skip: 0,
            filter: `server_id eq ${serverId}`
        }
    });
};

const getServerLicense = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_SERVER_LICENSE,
        routeParameters: {server_id: serverId.toString()}
    });
};

const initLicense = ({serverId, file}: { serverId: number; file: File }) => {
    return API.request({
        routeID: HallsAPIRoutes.UPLOAD_LICENSE_SEED,
        parameters: {
            file
        },
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const cancelLicenseProcess = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.CANCEL_LICENSE_PROCESS,
        routeParameters: {server_id: serverId.toString()}
    });
};

const rejectLicenseId = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.REJECT_LICENSE_ID,
        routeParameters: {server_id: serverId.toString()}
    });
};

const confirmLicenseId = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.CONFIRM_LICENSE_ID,
        routeParameters: {server_id: serverId.toString()}
    });
};

const updateLicenseDuration = ({
                                   serverId,
                                   duration
                               }: {
    serverId: number;
    duration: number;
}) => {
    return API.request({
        routeID: HallsAPIRoutes.UPDATE_LICENSE_DURATION,
        routeParameters: {server_id: serverId.toString()},
        parameters: {
            duration: duration
        }
    });
};

const getLicenseDownload = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_LICENSE_DOWNLOAD,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const setLicenseApplied = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.SET_LICENSE_APPLIED,
        routeParameters: {server_id: serverId.toString()}
    });
};

const renewLicense = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.RENEW_LICENSE,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const updateRemotelyLicense = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.UPDATE_REMOTELY_LICENSE,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const invalidateLicense = ({serverId}: { serverId: number }) => {
    return API.request({
        routeID: HallsAPIRoutes.INVALIDATE_LICENSE,
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const getLicenses = ({filter = null}: { filter: string }) => {
    const odataParameters = {
        skip: 0 * 999,
        top: 999
    };

    if (filter) {
        odataParameters["filter"] = filter;
    }
    return API.request({
        routeID: HallsAPIRoutes.GET_SERVER_LICENSES,
        odataParameters
    });
};

const getLicensesActivity = ({
                                 serverId,
                                 page,
                                 top = 10
                             }: {
    serverId: number;
    page: number;
    top: number;
}) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_LICENSE_ACTIVITY,
        odataParameters: {
            skip: page * top,
            top,
            filter: `server_id eq ${serverId}`,
            orderby: "-date"
        }
    });
};

const uploadSpecification = ({
                                 serverId,
                                 file
                             }: {
    serverId: number;
    file: File;
}) => {
    return API.request({
        routeID: HallsAPIRoutes.UPLOAD_SPECIFICATION,
        parameters: {
            file
        },
        routeParameters: {
            server_id: serverId.toString()
        }
    });
};

const getSpecificationActivity = ({
                                      serverId,
                                      page,
                                      top = 10
                                  }: {
    serverId: number;
    page: number;
    top: number;
}) => {
    return API.request({
        routeID: HallsAPIRoutes.GET_SERVER_SPECS,
        odataParameters: {
            skip: page * top,
            top,
            filter: `server_id eq ${serverId}`,
            orderby: "-inserted_at"
        }
    });
};

const getDynamicHall = subsidiary => {
    return API.request({
        routeID: HallsAPIRoutes.GET_DYNAMIC_HALL,
        routeParameters: {subsidiary: subsidiary.toString()}
    });
};

const getDynamicHallInfo = hallCode => {
    return API.request({
        routeID: HallsAPIRoutes.GET_DYNAMIC_HALL_INFO,
        routeParameters: {hall_code: hallCode.toString()}
    });
};

const getProductionServer = () => {
    return API.request({
        routeID: HallsAPIRoutes.GET_PRODUCTION_INFO
    })
}

const uploadConfigurationRemotely = ({serverId, update_time = null}: { serverId: number, update_time: string }) => {
    return API.request({
        routeID: HallsAPIRoutes.UPLOAD_CONFIGURATION_REMOTELY,
        routeParameters: {
            server_id: serverId.toString()
        },
        parameters: {
            update_time: update_time
        }
    });
};

export const hallsAPI = {
    getHalls,
    getHall,
    getServers,
    getServer,
    getSubsidiaries,

    //getStatusTimestamp,
    getConfigurationsList,
    searchOSMAddress,
    reverseOSMAddress,
    createHall,
    updateHall,
    createServer,
    cloneServer,
    getHallListServers,
    //getCashSystems,
    getCoreVersions,
    activateHall,
    deleteHall,
    activateServer,
    toggleServerDebugMode,
    toggleServerPerpetualLicense,
    getServersInfo,
    updateServer,
    getCompareConfigurations,
    uploadConfiguration,
    getTimezones,
    getServerLicenseState,
    getServerLicense,
    initLicense,
    cancelLicenseProcess,
    rejectLicenseId,
    confirmLicenseId,
    updateLicenseDuration,
    getLicenseDownload,
    setLicenseApplied,
    renewLicense,
    updateRemotelyLicense,
    invalidateLicense,
    getLicenses,
    getLicensesActivity,

    uploadSpecification,
    getSpecificationActivity,

    getDynamicHall,
    getDynamicHallInfo,

    getProductionServer,

    uploadConfigurationRemotely
};
